import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const getAllLanguages = () => {
    return vdkEmHappinessPortalApi.get('/languages/get-all');
};
const LanguagesApi = {
    getAllLanguages
};
export default LanguagesApi;
